import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Masters0Puppets from './App';

ReactDOM.render(
  <React.StrictMode>
    <Masters0Puppets />
  </React.StrictMode>,
  document.getElementById('root')
);